export default "__VITE_ASSET__0dcfb80a__"